var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1353"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73",
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 39823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.4375 36C28.9844 36 28.6172 35.6328 28.6172 35.1797V20.3047C28.6172 19.8516 28.9844 19.4844 29.4375 19.4844C29.8906 19.4844 30.2578 19.8516 30.2578 20.3047V35.1797C30.2578 35.6328 29.8906 36 29.4375 36Z",
    fill: "#7B8396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.2578 35.1797V20.3047C30.2578 19.8516 29.8906 19.4844 29.4375 19.4844V36C29.8906 36 30.2578 35.6328 30.2578 35.1797Z",
    fill: "#69737D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.4375 21.125C25.8189 21.125 22.875 18.1811 22.875 14.5625C22.875 10.9439 25.8189 8 29.4375 8C33.0561 8 36 10.9439 36 14.5625C36 18.1811 33.0561 21.125 29.4375 21.125Z",
    fill: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.4375 19.4844C26.7236 19.4844 24.5156 17.2764 24.5156 14.5625C24.5156 11.8486 26.7236 9.64062 29.4375 9.64062C32.1514 9.64062 34.3594 11.8486 34.3594 14.5625C34.3594 17.2764 32.1514 19.4844 29.4375 19.4844Z",
    fill: "#536EEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.8672 27.25H12.375C12.0973 27.25 11.8384 27.1094 11.6871 26.8768C11.5359 26.6437 11.5126 26.3502 11.6254 26.0964L13.0913 22.7985C13.6612 21.5161 14.9361 20.6875 16.3394 20.6875H22.9028C24.3061 20.6875 25.5812 21.5161 26.1509 22.7985L27.6168 26.0966C27.7296 26.3504 27.7063 26.644 27.5551 26.8768C27.4038 27.1094 27.1449 27.25 26.8672 27.25Z",
    fill: "#FF4C4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M31.2422 33.8125H8.82031C8.36722 33.8125 8 33.4453 8 32.9922V29.1641C8 27.2041 9.5947 25.6094 11.5547 25.6094H26.8672C29.7319 25.6094 32.0625 27.94 32.0625 30.8047V32.9922C32.0625 33.4453 31.6953 33.8125 31.2422 33.8125Z",
    fill: "#FF4C4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.9228 29.9844H29.0547C28.6016 29.9844 28.2344 29.6172 28.2344 29.1641C28.2344 28.711 28.6016 28.3438 29.0547 28.3438H30.9228C31.3759 28.3438 31.7431 28.711 31.7431 29.1641C31.7431 29.6172 31.3759 29.9844 30.9228 29.9844Z",
    fill: "#FAC30F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.7188 36C24.0602 36 22.7109 34.6508 22.7109 32.9922C22.7109 31.3336 24.0602 29.9844 25.7188 29.9844C27.3773 29.9844 28.7266 31.3336 28.7266 32.9922C28.7266 34.6508 27.3773 36 25.7188 36Z",
    fill: "#444D55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.9609 36C12.3024 36 10.9531 34.6508 10.9531 32.9922C10.9531 31.3336 12.3024 29.9844 13.9609 29.9844C15.6195 29.9844 16.9688 31.3336 16.9688 32.9922C16.9688 34.6508 15.6195 36 13.9609 36Z",
    fill: "#545C64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M20.5781 25.6094H25.6049L24.6517 23.4648C24.3449 22.7744 23.6584 22.3281 22.9028 22.3281H20.5781V25.6094Z",
    fill: "#37C8D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.9369 22.3281H16.3388C15.5833 22.3281 14.8967 22.7744 14.5899 23.4648L13.6367 25.6094H18.9369V22.3281Z",
    fill: "#44E9EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M29.9844 11.2812H28.3438C27.8907 11.2812 27.5234 11.6485 27.5234 12.1016V17.0234C27.5234 17.4765 27.8907 17.8438 28.3438 17.8438C28.7968 17.8438 29.1641 17.4765 29.1641 17.0234V16.2031H29.9844C31.3413 16.2031 32.4453 15.0991 32.4453 13.7422C32.4453 12.3853 31.3413 11.2812 29.9844 11.2812ZM29.9844 14.5625H29.1641V12.9219H29.9844C30.4366 12.9219 30.8047 13.2899 30.8047 13.7422C30.8047 14.1944 30.4366 14.5625 29.9844 14.5625Z",
    fill: "#E6F0F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M25.7188 34.3594C24.9649 34.3594 24.3516 33.7461 24.3516 32.9922C24.3516 32.2383 24.9649 31.625 25.7188 31.625C26.4726 31.625 27.0859 32.2383 27.0859 32.9922C27.0859 33.7461 26.4726 34.3594 25.7188 34.3594Z",
    fill: "#C8DCE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M13.9609 34.3594C13.2071 34.3594 12.5938 33.7461 12.5938 32.9922C12.5938 32.2383 13.2071 31.625 13.9609 31.625C14.7148 31.625 15.3281 32.2383 15.3281 32.9922C15.3281 33.7461 14.7148 34.3594 13.9609 34.3594Z",
    fill: "#E6F0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.a1e86da4777e859cd2df83da84b6d02d.svg";
export { ForwardRef as ReactComponent };